import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';

const TermsPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <section className="pt-32 pb-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="heading-1 mb-8">Terms and Conditions</h1>
            
            <div className="prose prose-gray max-w-none space-y-8">
              {/* Section 1 */}
              <section>
                <h2 className="heading-3 mb-4">1. Definitions</h2>
                <p className="text-gray-600 leading-relaxed mb-4">1.1 The following words have the following meanings:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>(a) "Buyer" means the customer (or any other person acting on behalf of and with the authority of the buyer).</li>
                  <li>(b) "Seller" means GREEN CIRCLE SOLUTIONS PTY LTD (trade as Supa Energy Hub) ABN 60 677 930 826.</li>
                  <li>(c) "Authorised Person" means any representative, associate, officer, employee, agent or subcontractor of SUPA ENERGY HUB.</li>
                  <li>(d) "Goods" means any or all of the products supplied by SUPA ENERGY HUB.</li>
                  <li>(e) "Services" means any or all of the installation services provided by SUPA ENERGY HUB.</li>
                  <li>(f) "Price" means the price payable for the goods and/or services as set out in the quote/contract.</li>
                </ul>
              </section>

              {/* Section 2 */}
              <section>
                <h2 className="heading-3 mb-4">2. Customer Declaration</h2>
                <p className="text-gray-600 leading-relaxed mb-4">The Buyer declares that:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>2.1 The Buyer is over the age of 18.</li>
                  <li>2.2 The Buyer is either the sole or one of the registered owners of the property on which installation is to be done under this contract.</li>
                  <li>2.3 The Buyer has never received or has been approved any solar grant/rebate for a small generation solar PV system on the installation address mentioned on this contract.</li>
                </ul>
              </section>

              {/* Section 3 */}
              <section>
                <h2 className="heading-3 mb-4">3. Offer, Acceptance and Cancellation</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>3.1 If the buyer accepts the quote and signs the contract, it becomes a legally binding agreement between the buyer and seller.</li>
                  <li>3.2 If the buyer doesn't accept the quote within 10 business days from the issuance of the quote, this quote will stand null and void and non-binding on both parties.</li>
                  <li>3.3 Under Australian Consumer Law and the relevant State Buildings Act, the buyer has a right to cancel the agreement within 10 business days from and including the day the buyer signs the agreement.</li>
                  <li>3.4 The buyer may cancel the agreement without penalty as long as the cancellation is within the cooling-off period. The penalty can be avoided by the buyer outside of the cooling-off period as long as the cancellation request is provided in writing and is communicated to the seller no later than 7 days prior to the installation day confirmed by the buyer.</li>
                </ul>
              </section>

              {/* Section 4 */}
              <section>
                <h2 className="heading-3 mb-4">4. Electricity Meter Changeovers, Switchboard Upgrades & Electrical Inspections</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>4.1 The buyer acknowledges and agrees that the electricity meter changeovers and switchboard upgrades associated with the goods and services under the contract may not form part of the Agreement and that these services (if provided by the seller) will be charged separately unless such services and related amounts are specifically included as part of goods and services being supplied under this Agreement.</li>
                  <li>4.2 The buyer acknowledges and agrees that an electrical inspection related to the installation of the goods at the Buyer's premises may be required prior to the goods becoming operational.</li>
                  <li>4.3 The Buyer's obligation to make payment to the Seller for the supply of goods and services is not affected by any delay by a third party in performing any electricity meter changeovers, switchboard upgrades or electrical inspections.</li>
                </ul>
              </section>

              {/* Section 5 */}
              <section>
                <h2 className="heading-3 mb-4">5. Payment</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>5.1 At the Seller's sole discretion the price shall be: (a) As indicated on invoices provided by the Seller to the Buyer in respect of Goods and Services Supplied; or (b) The Seller's quoted price which shall be binding on the Seller provided that the Buyer accepts the Seller's quotation within 10 business days</li>
                  <li>5.2 GST and other taxes and duties that may be applicable shall be added to the price except when they are expressly included in the price.</li>
                  <li>5.3 The Seller will draw to the attention of the consumer specific requirements of the contract which, if not brought to the consumer's attention, are likely to result in a dispute.</li>
                  <li>5.4 The Seller is not liable to pay any extra charges to make the Buyer's home/business premises safe to install upon.</li>
                  <li>5.5 Payment is due in full on the installation day or prior. Payment must be made via Bank Transfers or EFT, Cheque or Credit Card (Master Card / VISA). If the payment is made via EFT, the transaction must be completed within 48 hours prior to installation.</li>
                  <li>5.6 Any cost incurred for debt recovery (if needed) will be passed on in full to the Buyer.</li>
                  <li>5.7 The Buyer agrees to assign the STCs to The Seller as part of the system payment.</li>
                  <li>5.8 In case the Buyer decides to claim the STCs or is not eligible to receive STCs, the complete payment of the system is due before the installation.</li>
                  <li>5.9 The Buyer acknowledges that any breach of conditions of the STCs incentive regulations may hold the Buyer financially liable to the office of the Clean Energy Regulator.</li>
                  <li>5.10 The Buyer acknowledges that the ownership and all rights associated with the ownership of Goods supplied under this contract will pass on to the Buyer upon The Seller receiving complete payment for the Goods and Services provided under this contract.</li>
                  <li>5.11 Failure to pay the complete amount may result in The Seller taking legal action. In such events, the warranties provided will be void.</li>
                </ul>
              </section>

              {/* Section 6 */}
              <section>
                <h2 className="heading-3 mb-4">6. Standard Installation Conditions</h2>
                <p className="text-gray-600 leading-relaxed mb-4">6.1 As each installation is different, sometimes there is additional work that needs to be done to complete the Buyer's job that the Seller only finds out once its technicians are on the job.</p>
                
                <h3 className="font-semibold text-[#3D5A47] mt-6 mb-3">6.2 Services Included in Standard Installation:</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Delivery of the Buyer's system to the property on the installation date</li>
                  <li>Supply and install all parts of the Buyer's system per the manufacturer's instructions and relevant Australian Standards</li>
                  <li>Supply and installation of a suitable mounting base including Tin and Tile roof</li>
                  <li>Supply and install all DC cabling, switchgear and protection</li>
                  <li>Supply of up to 30 metres of DC electrical cabling between solar panels, inverter and switchboard</li>
                  <li>Supply of up to 30 metres of AC electrical cabling between inverter and switchboard</li>
                  <li>Testing and commissioning of the system after installation</li>
                  <li>Provision of a certificate of electrical safety</li>
                  <li>Demonstration of basic operations to the Buyer</li>
                  <li>Completion and submission of all DNSP pre-approval paperwork</li>
                </ul>

                <h3 className="font-semibold text-[#3D5A47] mt-6 mb-3">6.3 Services Excluded from Standard Installation:</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Any roof frames or roof support to support the solar PV panels</li>
                  <li>Supply and installation of Kliplok roof brackets</li>
                  <li>Supply and installation of tilt frames for roof pitch less than 10 degrees</li>
                  <li>Supply of more than 30 metres of electrical cable</li>
                  <li>Rectification of an inadequate existing electrical supply</li>
                  <li>Installing or upgrading a safety switch, switchboard, or meter panel board</li>
                  <li>Any trenching or excavation required for installation</li>
                  <li>Special access equipment (boom lifts, cherry pickers, cranes or scaffolding)</li>
                  <li>Removal of asbestos or investigation for asbestos</li>
                  <li>Multi-storey installation additional costs</li>
                </ul>

                <h3 className="font-semibold text-[#3D5A47] mt-6 mb-3">6.4 Customer's Obligations:</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Ensure proper and safe access to the property</li>
                  <li>Ensure all approvals and permits from local council and planning authorities</li>
                  <li>If renting, ensure owner's written permission</li>
                  <li>Be present at the property during installation</li>
                  <li>Agree to any variations before additional work is completed</li>
                </ul>
              </section>

              {/* Section 7 */}
              <section>
                <h2 className="heading-3 mb-4">7. Variations to Quote</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>7.1 Once the consumer has signed the contract, any variations to the system design must be documented and signed off by the consumer prior to installation.</li>
                  <li>7.2 The price set out in the quote is based on a standard installation condition plus any other specific variations referred to in the quote.</li>
                  <li>7.3 If the installation requires additional items, the Seller will advise the Buyer and provide updated costs before proceeding.</li>
                  <li>7.4 If the Buyer does not agree to pay for variations and the final system design is significantly different, either party may terminate this contract with a full refund.</li>
                </ul>
              </section>

              {/* Section 8 */}
              <section>
                <h2 className="heading-3 mb-4">8. Obligations</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>8.1 The Seller will provide the Buyer with the system specified in the quote, and will arrange for installation by a Clean Energy Council (CEC) accredited installer.</li>
                  <li>8.2 All work under this contract will comply with the Clean Energy Council Solar Retailer Code of Conduct.</li>
                </ul>
              </section>

              {/* Section 9 */}
              <section>
                <h2 className="heading-3 mb-4">9. Liabilities</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>9.1 The Seller accepts no liability or responsibility in respect of Feed-in-Tariff.</li>
                  <li>9.2 The Seller accepts no responsibility for any damage or loss caused to the Buyer's property by the installer which has not been the result of the installer's negligence.</li>
                  <li>9.3 The Seller will not be responsible for damage to old and brittle roof tiles being cracked/damaged during installation.</li>
                  <li>9.4 The Seller will not be responsible for any additional cost to be incurred in respect of meter upgrade if needed.</li>
                </ul>
              </section>

              {/* Section 10 */}
              <section>
                <h2 className="heading-3 mb-4">10. Warranties</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>10.1 Goods and services supplied under this contract are subject to warranties set out in the documentation provided at the time of installation.</li>
                  <li>10.2 Under the Australian Consumer Law, consumer guarantees come into effect automatically when goods and services are supplied.</li>
                  <li>10.3 The Seller's Goods and Services are supplied with the Seller's retailer warranty (including performance warranty and whole solar PV system warranty) for a minimum of 5 years.</li>
                  <li>10.4 Notification of defects must be made in writing within the warranty period.</li>
                  <li>10.5 Where defective workmanship is reported within the warranty period, the Seller will replace or remedy the defect.</li>
                  <li>10.6 Services come with an onsite warranty (labour and service call).</li>
                  <li>10.7 Warranty claims must be made in a timely manner (within 1 month) of becoming known.</li>
                  <li>10.8 All warranties are applicable to the original purchaser and are not transferrable unless otherwise stated.</li>
                </ul>
              </section>

              {/* Section 11 */}
              <section>
                <h2 className="heading-3 mb-4">11. Delivery</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>11.1 The Seller will make every reasonable effort to install the Goods and provide Services in a timely manner. The Seller will not be responsible for delays due to events outside its control.</li>
                  <li>11.2 Delay in installation for such reasons are not valid grounds for cancellation.</li>
                  <li>11.3 Additional costs may apply for difficult site access not notified at time of quote.</li>
                  <li>11.4 A homeowner must be present during installation to sign mandatory declarations. A rescheduling fee of $300 applies if installation is delayed due to homeowner absence.</li>
                  <li>11.5 Modifications to the original contract will incur an admin charge of $200.</li>
                </ul>
              </section>

              {/* Section 12 */}
              <section>
                <h2 className="heading-3 mb-4">12. Privacy</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>12.1 The Buyer agrees to provide The Seller with whatever personal information is required for efficient functioning, including information relevant to STCs and Grid Connection.</li>
                  <li>12.2 Personal information will be passed on only to contractors, employees, installers, and relevant bodies essential to delivery of Goods and Services.</li>
                  <li>12.3 The Seller will not share Buyer's personal information with third parties other than those mentioned above.</li>
                  <li>12.4 The Seller agrees that Buyer's personal information will not be sold to any third party under any circumstances.</li>
                </ul>
              </section>

              {/* Section 13 */}
              <section>
                <h2 className="heading-3 mb-4">13. Cooling Off Period</h2>
                <p className="text-gray-600 leading-relaxed">
                  13.1 Under Australian Consumer Law and relevant State Building Acts, the Buyer is entitled to a cooling off period of ten (10) working days from and including the date the Buyer signs the agreement. All notifications must be received by The Seller in writing via email, fax or post.
                </p>
              </section>

              {/* Section 14 */}
              <section>
                <h2 className="heading-3 mb-4">14. Finance</h2>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>14.1 The Buyer understands that The Seller will assist in obtaining finance/payment plan products from external providers.</li>
                  <li>14.2 Where payment is denied by the external finance provider due to issues with the Buyer, The Seller will have the right to claim the amount from the Buyer directly.</li>
                  <li>14.3 If The Seller is unable to recover payment, the Buyer acknowledges The Seller will be entitled to repossession of the Goods supplied.</li>
                </ul>
              </section>

              {/* Section 15 */}
              <section>
                <h2 className="heading-3 mb-4">15. Termination and Refunds</h2>
                <p className="text-gray-600 leading-relaxed mb-4">15.1 The Seller may terminate the contract with the Buyer in the event of:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>(a) The Buyer is found in breach of the terms and conditions</li>
                  <li>(b) Installation is not possible due to factors outside The Seller's control (full refund provided)</li>
                  <li>(c) Grid connection application is rejected (full refund provided)</li>
                  <li>(d) Buyer does not agree to variations and final design is significantly different (full refund provided)</li>
                  <li>(e) Estimated delivery timeframe not honoured for reasons within Seller's control (full refund upon request)</li>
                </ul>
              </section>

              {/* Section 16 */}
              <section>
                <h2 className="heading-3 mb-4">16. Estimated Timeframe for Supply and Installation</h2>
                <div className="overflow-x-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                    <div className="bg-[#B5D43B]/10 rounded-xl p-4 border border-[#B5D43B]/20">
                      <h4 className="font-semibold text-[#3D5A47] mb-2">Site Inspection</h4>
                      <p className="text-sm text-gray-600 mb-2">1-2 days</p>
                      <p className="text-xs text-gray-500">Our consultant will schedule and conduct a site inspection to assess roof, switchboard, and meter.</p>
                    </div>
                    <div className="bg-[#B5D43B]/10 rounded-xl p-4 border border-[#B5D43B]/20">
                      <h4 className="font-semibold text-[#3D5A47] mb-2">Pre-installation</h4>
                      <p className="text-sm text-gray-600 mb-2">1-2 weeks</p>
                      <p className="text-xs text-gray-500">Installation date and time scheduling, preparation for installation day.</p>
                    </div>
                    <div className="bg-[#B5D43B]/10 rounded-xl p-4 border border-[#B5D43B]/20">
                      <h4 className="font-semibold text-[#3D5A47] mb-2">Installation</h4>
                      <p className="text-sm text-gray-600 mb-2">1-2 days</p>
                      <p className="text-xs text-gray-500">Target date within 8 weeks from contract signed date, or within 4 weeks from Solar VIC approved date.</p>
                    </div>
                    <div className="bg-[#B5D43B]/10 rounded-xl p-4 border border-[#B5D43B]/20">
                      <h4 className="font-semibold text-[#3D5A47] mb-2">Inspection & Connection</h4>
                      <p className="text-sm text-gray-600 mb-2">2-8 weeks</p>
                      <p className="text-xs text-gray-500">Electrical inspection, Certificate of Electrical Safety, and retailer notification.</p>
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-500 mt-4 italic">
                  Note: Estimated timeframes may vary due to reasons beyond our control. Your electricity contract/tariff may change following installation of solar.
                </p>
              </section>

              {/* Contact */}
              <section className="pt-8 border-t border-black/10">
                <h2 className="heading-3 mb-4">Contact Us</h2>
                <p className="text-gray-600">
                  If you have any questions about these Terms and Conditions, please contact us:
                </p>
                <p className="text-gray-600 mt-3">
                  Email: {companyInfo.email}<br />
                  Phone: {companyInfo.phone}
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
